import VMasker from "./Vmask";
import TomSelect from "tom-select";

let data = [];

window.onload = async () => {
    await fetchData();
    new TomSelect("#first-select", {
        create: false,
        sortField: {
            field: "text",
            direction: "asc",
        },
    });

    new TomSelect("#second-select", {
        create: false,
        sortField: {
            field: "text",
            direction: "asc",
        },
    });

    VMasker(document.querySelector(".phone")).maskPattern("(99) 99999-9999");
    const email = document.querySelector(".email");
    email.addEventListener("input", ({ target: { value } }) => {
        const valid = validateEmail(value);
        if (!valid) {
            email.classList.add("error");
        } else {
            email.classList.remove("error");
        }
    });

    const telMask = ["(99) 9999-9999", "(99) 99999-9999"];
    const phone = document.querySelector(".phone");
    VMasker(phone).maskPattern(telMask[0]);
    phone.addEventListener(
        "input",
        inputHandler.bind(undefined, telMask, 14),
        false
    );
    phone.addEventListener("input", ({ target: { value } }) => {
        const valid = mphone(value);
        if (!valid) {
            phone.classList.add("error");
        } else {
            phone.classList.remove("error");
        }
    });

    const btn = document.querySelector(".submit input");
    btn.addEventListener("click", (event) => {
        event.preventDefault();
        validateForm("#step1");
    });

    const btnResult = document.querySelector(".show-result");
    btnResult.addEventListener("click", (event) => {
        event.preventDefault();
        validateForm("#step2");
        calc();

        document.querySelector("#step3 .ts-control").append(data.clone);
        document.querySelector("#step3 form input.dias").value = data.dias;
        document.querySelector("#step3 form input.clientes").value =
            data.clientes;
        document.querySelector("#step3 form input.money").value = data.preco;
    });

    const step3Inputs = document.querySelectorAll("#step3 form input");
    step3Inputs.forEach((input) => {
        input.addEventListener("change", (event) => {
            calc();
        });
    });

    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
        input.addEventListener("input", (event) => {
            handleData(event);
        });
    });

    const select_input = document.querySelectorAll(".ts-control input");
    select_input.forEach((input) => {
        input.addEventListener("focus", () => {
            setTimeout(() => {
                const select_wrapper = input.offsetParent.lastElementChild;
                if (select_wrapper.classList.contains("dropdown-active")) {
                    input.addEventListener("input", (event) => {
                        if (event.target.value != "") {
                            const items = document.querySelectorAll(".item");
                            items.forEach((item) => {
                                item.classList.add("item-hide");
                            });
                        }
                    });
                }
            }, 100);
        });
        input.addEventListener("focusout", () => {
            const items = document.querySelectorAll(".item");
            if (items) {
                items.forEach((item) => {
                    if (item.classList.contains("item-hide")) {
                        item.classList.remove("item-hide");
                    }
                });
            }
        });
    });
};

const fetchData = async () => {
    const response = await fetch(
        "https://engecass.arealocal.com.br/api/product"
    );
    const data = await response.json();

    if (data != "") {
        const selects = document.querySelectorAll("select");
        selects.forEach((select) => {
            for (const key in data) {
                let option = document.createElement("option");
                let value = data[key].valor_calculo;
                select.append(option);
                option.value = value;
                option.text = data[key].nome;
            }
        });
    }
};

const validateForm = (element) => {
    const step = document.querySelector(element);
    const form = document.querySelector(`${element} form`);
    const fields = [...document.querySelectorAll(`${element} .text`)];
    fields.forEach((field) => {
        if (field.value == "" || field.classList.contains("error"))
            form.classList.add("validate-error");
    });

    const formError =
        document.querySelector(".validate-error") ||
        document.querySelector(".error");
    if (formError) {
        formError.addEventListener("animationend", (event) => {
            if (event.animationName === "nono") {
                formError.classList.remove("validate-error");
            }
        });
    } else {
        step.classList.add("form-hide");
    }

    step.addEventListener("animationstart", (event) => {
        if (event.animationName === "down") {
            document.querySelector("body").style.overflow = "hidden";
        }
    });

    step.addEventListener("animationend", (event) => {
        if (event.animationName === "down") {
            if (element === "#step1") {
                const step2 = document.querySelector("#step2");
                step.style.display = "none";
                document.querySelector("body").style.overflow = "auto";
                step2.style.display = "block";
            } else if (element === "#step2") {
                const step3 = document.querySelector("#step3");
                step.style.display = "none";
                document.querySelector("body").style.overflow = "auto";
                step3.style.display = "block";
            }
        }
    });
};

const handleData = ({ target: { name, value } }) => {
    data = { ...data, [name]: value };
};

const calc = () => {
    const equipamento = document.querySelector(".item");
    const valor = equipamento.getAttribute("data-value");
    data.clone = equipamento.cloneNode(true);
    const { dias, clientes, preco } = data;

    let faturamento = dias * preco * clientes;

    const rows = document.querySelectorAll("tr");
    rows.forEach(async (element) => {
        if (element.querySelector("td")) {
            const taxa = element.querySelector("td:nth-of-type(2)").textContent;
            const atendimentosCol = element.querySelector("td:nth-of-type(3)");
            const faturamentosCol = element.querySelector("td:nth-of-type(4)");
            const mesesCol = element.querySelector("td:nth-of-type(5)");
            atendimentosCol.innerHTML = parseInt(
                (parseFloat(taxa) / 100) * dias
            );
            const total = (parseFloat(taxa) / 100) * faturamento;
            faturamentosCol.innerHTML = `R$ ${formatNumber(total)}`;
            const mes = valor / parseFloat(total);
            mesesCol.innerHTML = parseFloat(Math.round(mes));
        }
    });
};

const formatNumber = (
    amount,
    decimalCount = 2,
    decimal = ",",
    thousands = "."
) => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
            (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : "")
        );
    } catch (e) {
        console.log(e);
    }
};

const validateEmail = (email) => {
    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

const mphone = (v) => {
    if (v.length >= 14) {
        return true;
    }

    return false;
};

const inputHandler = (masks, max, event) => {
    var c = event.target;
    var v = c.value.replace(/\D/g, "");
    var m = c.value.length > max ? 1 : 0;
    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
};
